<template lang='pug'>
div.actions-container(:class="{'horizontal-layout': isHorizontalView}")
  AccountPaidStatus.pt-1(v-if="showAccount"
                    @open-account-pay="$emit('open-account-pay')")
  v-btn(outlined fab small color='accent'
        @click='$emit("info-action")')
    v-icon {{mdiInformationOutline}}
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            :disabled='isLoading || !hasUnsavedChanges'
            :loading='isBackendBusy'
            @click='$emit("save-changes")'
            v-bind='attrs'
            v-on='on')
        v-icon save
    span {{day6Resource.save}}
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            :disabled='isLoading || !isEditMode'
            @click='$emit("open-character-browser")'
            v-bind='attrs'
            v-on='on')
        v-icon folder
    span {{day6Resource.browserCharacters}}
  ShareAction(:isStacked="!isHorizontalView"
              :isLoading="isLoading"
              :isPendingShare="isPendingShare",
              :isSharing="isSharing"
              :shareLevel="shareLevel",
              :isQueryingShareLevel="isQueryingShareLevel"
              @share-character="$emit('share-character')")
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            :disabled='isLoading || isNotEditPoseMode || isBackendBusy || (isEditMode && (isPendingBuild || isProcessingBuild))'
            @click='$emit("toggle-build-pose")'
            v-bind='attrs'
            v-on='on')
        v-icon {{ isPoseMode ? mdiHuman : '$vuetify.icons.poseCharacter' }}
    span {{buildPoseHint}}
  //- v-tooltip(right open-delay='500')
  //-   template(v-slot:activator="{ on, attrs }")
  //-     v-btn(outlined fab small color='accent'
  //-           :disabled='isLoading || !isPoseMode || isBackendBusy'
  //-           @click='$emit("open-pose-library")'
  //-           v-bind='attrs'
  //-           v-on='on')
  //-       v-icon {{mdiBookOpenBlankVariant}}
  //-   span {{day6Resource.poseLibrary}}
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            :disabled='isLoading || isNotEditPoseMode || isBackendBusy'
            @click='$emit("estimate-pose")'
            v-bind='attrs'
            v-on='on')
        v-icon $estimatePose
    span {{day6Resource.detectPose}}
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            :disabled='isLoading || !isEditMode || isBackendBusy || isPendingBuild'
            :loading='isEditMode && isProcessingBuild'
            @click='$emit("start-download")'
            v-bind='attrs'
            v-on='on')
        v-icon {{ isPendingBuild ? mdiCalendarClock : 'download' }}
    span {{day6Resource.downloadHint}}
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            :disabled='isLoading || !isEditMode || isBackendBuildingProcessing'
            @click='$emit("preview-generated")'
            v-bind='attrs'
            v-on='on')
        v-icon {{mdiEyeOutline}}
    span {{day6Resource.previewGenerated}}
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            @click='$emit("mailing-list")')
        v-icon email
    span {{day6Resource.mailingList}}
  v-tooltip(right open-delay='500')
    template(v-slot:activator="{ on, attrs }")
      v-btn(outlined fab small color='accent'
            :disabled='isLoading || !isEditMode || isBackendBuildingProcessing'
            @click='$emit("restore-dimensions")'
            v-bind='attrs'
            v-on='on')
        v-icon {{mdiRestore}}
    span {{day6Resource.reset}}
</template>

<script>
import day6Resource from '@/resources/day6'
import {
  mdiHuman,
  mdiCalendarClock,
  mdiInformationOutline,
  mdiEyeOutline,
  mdiRestore,
  mdiBookOpenBlankVariant
} from '@mdi/js'
import AccountPaidStatus from '@/components/account/account-paid-status'
import ShareAction from './day6-share-action.vue'

export default {
  name: 'Day6EditorActionBar',
  components: { AccountPaidStatus, ShareAction },
  props: {
    isHorizontalView: Boolean,
    isLoading: Boolean,
    isEditMode: Boolean,
    isPoseMode: Boolean,
    hasUnsavedChanges: Boolean,
    showCharacterBrowser: Boolean,
    isBackendBusy: Boolean,
    isProcessingBuild: Boolean,
    isPendingBuild: Boolean,
    isPendingShare: Boolean,
    isSharing: Boolean,
    shareLevel: String,
    isQueryingShareLevel: Boolean,
    showAccount: Boolean,
    isAccountPaid: Boolean
  },
  data: function () {
    return {
      mdiHuman,
      mdiCalendarClock,
      mdiInformationOutline,
      mdiEyeOutline,
      mdiRestore,
      mdiBookOpenBlankVariant,
      day6Resource
    }
  },
  computed: {
    buildPoseHint () {
      return this.isEditMode
        ? (this.isAccountPaid ? day6Resource.poseAnimateCharacterHint : day6Resource.poseCharacterHint)
        : day6Resource.modelingCharacterHint
    },
    isNotEditPoseMode () {
      return !(this.isEditMode || this.isPoseMode)
    },
    isBackendBuildingProcessing () {
      return this.isBackendBusy || this.isPendingBuild || this.isProcessingBuild
    }
  }
}
</script>

<style lang="scss" scoped>
.actions-container {
  // TODO Move into styles and standardize
  --action-padding: 16px;
  --bar-size: 72px;

  min-width: var(--bar-size);
  display: flex;
  align-content: center;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  &:not(.horizontal-layout) {
    flex-direction: column;
    overflow-x: hidden;
    padding: 0 var(--action-padding) var(--action-padding) var(--action-padding);

    >*{
      margin-top: var(--action-padding);
    }
  }

  &.horizontal-layout {
    flex-direction: row;
    overflow-y: hidden;
    padding: var(--action-padding) 0 var(--action-padding) var(--action-padding);

    >* {
      margin-right: var(--action-padding);
    }
  }
}
</style>
